import { Strategy } from "../../../store/slices/strategySlice";
import { Stack } from "@mui/material";
import formatNumber from "../../../utils/formatNumber";
import { TimePresetRender } from "../../../_app/types";
import { printRuntime } from "../../../utils/utils";
import DottedTextField from "../../../_components/DottedTextField";
import BadgeDirection from "../../../_components/BadgeDirection";
import BadgeStatus from "../../../_components/BageStatus/BadgeStatus";
import Text from "../../../_components/Text";
import { FC } from "react";

interface AutoStrategyMainInfoProps {
  strategy: Strategy;
  botsCount: number;
}

const AutoStrategyMainInfo: FC<AutoStrategyMainInfoProps> = ({ strategy, botsCount }) => {
  return (
    <Stack width="100%">
      <Text variant="h2" mb="16px">
        Main info
      </Text>

      <Stack width="100%" direction={"column"} alignItems={"center"} gap="8px">
        <DottedTextField
          placeholder={`Status`}
          value={``}
          children={<BadgeStatus severity={strategy.status} />}
        />
        <DottedTextField placeholder={"Strategy ID"} value={strategy.displayedId} />
        <DottedTextField placeholder={"Pair"} value={`${strategy.base} / ${strategy.quote}`} />
        <DottedTextField
          placeholder={"Volume"}
          value={`${formatNumber(strategy.requiredMargin * strategy.leverage)} ${strategy.quote}`}
        />
        <DottedTextField
          placeholder={"Margin"}
          value={`${formatNumber(strategy.requiredMargin)} ${strategy.quote}`}
        />
        <DottedTextField placeholder={"Leverage"} value={`${strategy.leverage}x`} />
        <DottedTextField placeholder={"Runtime"} value={`${printRuntime(strategy.runtimeHours)}`} />
        <DottedTextField placeholder={"Bots created"} value={botsCount} />
        <DottedTextField
          placeholder={"Timeframe settings"}
          value={`${TimePresetRender[strategy.presetType]}${TimePresetRender[strategy.presetType] !== "Custom" ? "-term" : ""}`}
        />

        {strategy.positionBehaviour && (
          <DottedTextField placeholder={"Position behaviour"} value={strategy.positionBehaviour} />
        )}

        <DottedTextField
          placeholder={"Direction"}
          value={``}
          children={<BadgeDirection gridDirection={strategy.gridDirection} />}
        />
      </Stack>
    </Stack>
  );
};

export default AutoStrategyMainInfo;
